import React from 'react';
import '../assets/AllTabsCommon.css';
import '../assets/Reports.css';
import '../assets/Utilities.css';
import AIInsights from './AIInsights';


function Insights({ userInfo, role }) {
    // Directly render AI Insights without sub-tabs since Device Timeline has been moved
    return (
        <div className="content-tab-container">
            <AIInsights userInfo={userInfo} role={role} />
        </div>
    );
}

export default Insights;
